import React from 'react';

import { useStaticQuery, graphql } from 'gatsby';

const tagRegex = /(<([^>]+)>)/gi;
const removeTags = (str: string) => str.replace(tagRegex, '');

interface SEOargs {
  description?: string;
  lang?: string;
  title?: string;
  image?: string;
}

function SEO({ description, lang = 'ru', title, image }: SEOargs) {
  const {
    site: {
      siteMetadata: { siteImage, siteTitle, siteUrl, mainTitle, siteDescription, author },
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          mainTitle
          siteTitle: title
          siteImage: image
          siteDescription: description
          author
        }
      }
    }
  `);

  const headTitle = `${title || mainTitle} | ${siteTitle}`;

  const metaDescription = `${removeTags(description || siteDescription)} | ${siteTitle}`;

  const metaImage = image || `${siteUrl}${siteImage}`;

  return (
    <>
      <html lang={lang} />
      <title>{headTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={headTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:creator" content={author} />
      <meta property="twitter:title" content={headTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="image" content={metaImage} />
      <meta property="og:image" content={metaImage} />
      <meta property="twitter:image" content={metaImage} />
    </>
  );
}

export default SEO;
